import parseDialogue from "../../util/parseDialogue";

export const SuperphreakF2 = parseDialogue(`
superphreak:f2:100-400

#100 Newbie, are you reading me?
>200 Sure, go ahead.

#200 Great. I have some information for ~~~~ ~~~ ~~~~~~~~ ~ ~~~~~~~ ~~~~ ~~~~~ ~ ~~~~ ~~~~~~~
>300 You're breaking up.

#300 ~~~~ ~~~ ~~~~~~~~ ~ ~~~~~~~ ~~~~ ~~~~~ ~~~~~ ~ ~~~~ ~~~~~~ ~ ~~~~~~~~ ~~~~~ ~~~~~~ ~~~~~~~ ~~~~ ~~~~
>400 Close.
`);
